import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';

import { API_BASE_URL } from '../../../core/config/api-base-url.token';
import { environment } from '../../../../environments/environment';
import { TopicApiModel } from '../models/topic.model';

const MOCK_TOPICS: TopicApiModel[] = [
  {
    topic: 'Agriculture',
    categories: ['Cotton', 'Pomegranate', 'Solar Irrigation Pumps', 'Production'],
    _id: '56e6f3dec47ee81c061f628a',
    created: '2016-03-14T17:24:46.777Z',
    __v: 9,
    assetPath: 'https://numerical.co.in/uploads/agriculture.png',
    numeronCount: 422,
  },
];

@Injectable({
  providedIn: 'root',
})
export class TopicsService {
  private readonly httpClient = inject(HttpClient);
  private readonly apiBaseUrl = inject(API_BASE_URL);

  public getTopics(): Observable<TopicApiModel[]> {
    if (environment.useMockTopics) {
      return of(MOCK_TOPICS);
    }

    return this.httpClient.get<TopicApiModel[]>(`${this.apiBaseUrl}/topics`);
  }
}
